import { useEffect, useState } from 'react';
import { useEffectOnce } from 'react-use';
import { connect, useDispatch } from 'react-redux';
import type { Dispatch } from 'redux';

import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import { LawInterfacesEnum } from 'CorePackage/MainModule/enums/LawInterfacesEnum';
import { getLawInterface } from 'CorePackage/MainModule/reducers/coreReducer';
import { TableCheckItems } from 'CorePackage/MainModule/types/TableCheckItems';
import { initialPlanListTableColumns } from 'PlanListPackage/MainModule/constants/initialPlanListTableColumns';
import { getPlanListData } from 'PlanListPackage/MainModule/selectors/planListSelectors';
import { PlanListPanel } from 'PlanListPackage/PlanListPanelModule/components/PlanListPanel';
import { getSortOrder } from 'CorePackage/MainModule/common/getSortOrder';
import { getSortOrderByYear } from 'CorePackage/MainModule/common/getSortOrderByYear';
import { TablePage } from 'CorePackage/TableModule/components/TablePage';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

import { TemplatesTable } from './PlanListTable';
import { planListSetOrder, planListInitPage } from '../actions/planListActions';
import { IKnmPlan } from '../interfaces/IKnmPlan';
import { initialPlanListTableColumnsErknm } from '../constants/initialPlanListTableColumnsErknm';

interface IPlanListStoreProps {
  plans: IKnmPlan[];
  isErknm: boolean;
}

const PlanListWithoutStore = ({ isErknm, plans }: IPlanListStoreProps) => {
  const [itemsCheck, setItemsCheck] = useState<TableCheckItems>({});
  const [searchInputValue, setSearchInputValue] = useState('');
  const [tableColumns, setTableColumns] = useState(
    isErknm ? initialPlanListTableColumnsErknm : initialPlanListTableColumns,
  );

  const dispatch = useDispatch<Dispatch<RootActions>>();

  useEffect(() => {
    const newTableColumns = isErknm ? initialPlanListTableColumnsErknm : initialPlanListTableColumns;

    setTableColumns(newTableColumns);
    const order = getSortOrder(newTableColumns, getSortOrderByYear);

    dispatch(planListSetOrder(order));
  }, [dispatch, isErknm]);

  useEffect(() => {
    const newItemsCheck: TableCheckItems = {};

    plans.forEach(plan => {
      newItemsCheck[String(plan.id)] = false;
    });
    setItemsCheck(newItemsCheck);
  }, [plans]);

  useEffectOnce(() => {
    dispatch(planListInitPage());
  });

  return (
    <TablePage>
      <PlanListPanel
        itemsCheck={itemsCheck}
        searchInputValue={searchInputValue}
        setSearchInputValue={setSearchInputValue}
      />
      <TemplatesTable
        columns={tableColumns}
        itemsCheck={itemsCheck}
        searchInputValue={searchInputValue}
        setItemsCheck={setItemsCheck}
        setTableColumns={setTableColumns}
      />
    </TablePage>
  );
};

const mapStateToProps = (state: IRootState): IPlanListStoreProps => ({
  plans: getPlanListData(state),
  isErknm: getLawInterface(state) === LawInterfacesEnum.FZ_248,
});

export const PlanList = connect(mapStateToProps)(PlanListWithoutStore);
